import { createPinia } from "pinia";
let piniaInstance;
export function getPinia() {
  if (!piniaInstance) {
    piniaInstance = createPinia();
  }
  return piniaInstance;
}